import React from 'react';
import SupportButtons from './SupportButtons';
import OtherWaysToSupport from '@gik/inkind-page/components/InkindSupportSidebar/OtherWaysToSupport';
import bemBlock from '@gik/core/utils/bemBlock';

export interface IInkindSupportSidebarProps {
  inkindRouteId: string;
}

export default function InkindSupportSidebar({ inkindRouteId }: IInkindSupportSidebarProps) {
  const bem = bemBlock('support-sidebar');

  return (
    <div className={bem()}>
      <SupportButtons inkindRouteId={inkindRouteId} />
      <OtherWaysToSupport inkindRouteId={inkindRouteId} />
    </div>
  );
}
